import { render, staticRenderFns } from "./organDetail.vue?vue&type=template&id=25abc363&scoped=true"
import script from "./organDetail.vue?vue&type=script&lang=js"
export * from "./organDetail.vue?vue&type=script&lang=js"
import style0 from "./organDetail.vue?vue&type=style&index=0&id=25abc363&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25abc363",
  null
  
)

export default component.exports